/** @jsx jsx */

import { css, jsx } from '@emotion/core';

import Markdown from 'app/developer-v3/components/Markdown';

import type { Version } from './types';

const Styles = {
  root: css`
    ul {
      margin: 0;

      a {
        text-decoration: underline !important;
        font-weight: 400 !important;
      }
    }
  `,
};

type Props = {
  version: Version;
};

function ColumnChangelog({ version }: Props) {
  return (
    <div css={Styles.root}>
      <Markdown linkTarget="_blank" source={version.changelog || ''} />
    </div>
  );
}

export default ColumnChangelog;
